import React from "react";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import '../styles/LoginCss.css';
import TruveyGreenLogo from '../Asset/Images/XSO-White.png';
import apiService from '../Services/apiService';

const ForgetPassword = () => {
    const navigate = useNavigate();
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [email, setEmail] = useState("");
    const [PhoneNumber, setPhoneNumber] = useState("");
    const [PhoneNumberOTP, setPhoneNumberOTP] = useState("");
    const [Password, setPassword] = useState();
    const [ConfirmPassword, setConfirmPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [RequestID, setRequestID] = useState();
    const [error, setError] = useState("");
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem("JWTToken");
        if (token) {
            navigate("/SurveyList")
        } else {
            setIsLoggedIn(false);
        }
    }, []);

    const FormClick = async (e) => {
        e.preventDefault();
        setErrorMessage("");
        if (!email || !PhoneNumber) {
            setErrorMessage("Please fill out all fields.");
            return;
        }
        try {
            const response = await apiService.ResetPassword(email, PhoneNumber);
            if (response != null) {
                debugger;
                alert(response.Message);
                if (response.Status === "Success") {
                    setFormSubmitted(true);
                    setRequestID(response.Response[0].RequestID);
                }
                return;
            }
            else {
                // setErrorMessage("Login Successfully");
                // localStorage.setItem("UserEmail",email)
                // localStorage.setItem("JWTToken", JWTToken);
                // navigate("/SurveyList");
            }
        } catch (error) {
            setErrorMessage(error.message);
        }
    };
    const ResetPassword = async () => {
        setError("");

        if (!PhoneNumberOTP.trim()) {
            setError("Please enter the OTP.");
            return;
        }

        if (!Password.trim() || !ConfirmPassword.trim()) {
            setError("Password fields cannot be empty.");
            return;
        }

        if (Password.length < 6) {
            setError("Password must be at least 6 characters long.");
            return;
        }

        if (Password !== ConfirmPassword) {
            setError("Passwords do not match!");
            return;
        }

        if (!RequestID) {
            setError("Invalid request. Please try again.");
            return;
        }

        try {
            const response = await apiService.VerifyResetOTP(RequestID, PhoneNumberOTP, Password);

            if (response && response.Status === "Success") {
                alert(response.Message);
                if (response.Status === "Success") {
                    navigate("/Login")
                }
            }
        } catch (error) {
            setError(error.message || "An error occurred while resetting the password.");
        }
    };
    const handleConfirmPasswordChange = (e) => {
        setConfirmPassword(e.target.value);
        if (e.target.value !== Password) {
            setError("Passwords do not match!");
        } else {
            setError("");
        }
    };
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };
    return (<>
        <section className="TruveyBG min-hight99vh py-5">
            <div className="container">
                <div className="row d-flex align-items-center justify-content-center h-100">
                    <div className="col-md-7 col-lg-6 col-xl-5">
                        <div className="d-none d-md-block text-center" style={{ width: "100%" }}>
                            <Link to="/" className="d-block">
                                <img src={TruveyGreenLogo} alt="Logo" className="w-50" />
                            </Link>
                        </div>
                    </div>
                    <div
                        className="col-md-5 col-lg-5 col-xl-5 offset-xl-1 p-3 bg-white"
                        style={{
                            borderRadius: "1rem",
                            boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                        }}>
                        <div className="p-3">
                            <h2 className="text-center fw-bold mb-4">Forget Password</h2>

                            {formSubmitted ? (<>
                                <div>
                                    <div className="form-group">
                                        <div className="form-group">
                                            <label htmlFor="mobileotp" className="form-label">Email OTP</label>
                                            <span className="text-danger">*</span>
                                            <div className="input-group rounded-pill mb-2">
                                                <input
                                                    type="number"
                                                    id="mobileotp"
                                                    className="form-control rounded-2"
                                                    value={PhoneNumberOTP}
                                                    maxLength={10}
                                                    onChange={(e) => setPhoneNumberOTP(e.target.value)}
                                                    required
                                                />
                                            </div>
                                            <label htmlFor="Password" className="form-label">Password</label>
                                            <span className="text-danger">*</span>
                                            <div className="input-group rounded-pill mb-2">
                                                <input
                                                    type={showPassword ? 'text' : 'password'}
                                                    id="Password"
                                                    className="form-control rounded-2"
                                                    value={Password}
                                                    maxLength={10}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                    required
                                                />
                                            </div>
                                            <label htmlFor="ConfirmPassword" className="form-label">Confirm Password</label>
                                            <span className="text-danger">*</span>
                                            <div className="input-group rounded-pill mb-2">
                                                <input
                                                    type={showConfirmPassword ? "text" : "password"}
                                                    id="ConfirmPassword"
                                                    className="form-control rounded-start-2"
                                                    value={ConfirmPassword}
                                                    maxLength={10}
                                                    onChange={handleConfirmPasswordChange}
                                                    required
                                                />
                                                <span
                                                    className="input-group-text border-0"
                                                    onClick={toggleConfirmPasswordVisibility}
                                                    style={{ cursor: "pointer", backgroundColor: "#f0f0f0" }}
                                                >
                                                    <i className={showConfirmPassword ? "fas fa-eye-slash" : "fas fa-eye"}></i>
                                                </span>
                                            </div>
                                        </div>
                                        {error && <p className="text-danger">{error}</p>}
                                    </div>
                                    <button
                                        type="submit"
                                        className="btn btn-custom btn-lg btn-block form-control mt-4 mb-4"
                                        onClick={ResetPassword}
                                    >
                                        Reset Password
                                    </button>
                                </div>
                            </>) :
                                (<>
                                    <form onSubmit={FormClick}>
                                        <div className="form-group">
                                            <label htmlFor="email" className="form-label">
                                                Registered Email <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <input
                                                type="email"
                                                id="email"
                                                className="form-control mb-2"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div className="form-group">
                                            <div className="form-group">
                                                <label htmlFor="mobile" className="form-label">Registered  PhoneNumber</label>
                                                <span className="text-danger">*</span>
                                                <div className="input-group rounded-pill mb-2">
                                                    <span className="input-group-text border-0">+91</span>
                                                    <input
                                                        type="tel"
                                                        id="mobile"
                                                        className="form-control rounded-2"
                                                        value={PhoneNumber}
                                                        maxLength={10}
                                                        onChange={(e) => setPhoneNumber(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <button
                                            type="submit"
                                            className="btn btn-custom btn-lg btn-block form-control mt-4 mb-4"
                                        >
                                            Next
                                        </button>
                                        {errorMessage && <p className="text-danger">{errorMessage}</p>}
                                    </form>
                                </>)}

                            <div className="d-flex justify-content-around align-items-center mt-4 mb-4">
                                <p>
                                    <Link to="/Login">Login Now</Link>
                                </p>
                                <p>
                                    Don't have an account? <Link to="/SignUp">Register now</Link>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>)
}
export default ForgetPassword;